import { takeEvery } from 'redux-saga/effects';

import { ActionTypes } from '../constants';
import { moveScreen } from './moveScreen';

export default [
  takeEvery(ActionTypes.MOVE_SCREEN, moveScreen),
];
